<template>
  <div class="animated fadeIn">
    <b-form @submit="exportJson">
      <b-form-group
              label="Project:"
              description="This field is required"
      >
        <select class="form-control" v-model="form.project_id" required>
          <option value="">Please Select</option>
          <option v-for="project in projects" :value="project.id">
            {{project.title}}
          </option>
        </select>
      </b-form-group>

      <div class="text-right">
        <b-button type="submit" variant="dark" size="sm"><font-awesome-icon icon="save" /> Process and Download File</b-button>
      </div>
    </b-form>
  </div>
</template>
<script>
    import {bus} from '@/main.js';
    import SwalMixin from '@/views/mixins/Swal.js'
    import { server_details } from "@/config";
    export default {
      mixins:[SwalMixin],
      data: () => {
          return {
            form:{
              project_id:"",
            },
            projects:[]
          }
      },
      created(){
        this.getProjects();
      },
      methods: {

        getProjects(){
          this.axios.get('projects/all').then(response => {
            this.projects = JSON.parse(JSON.stringify(response.data));
          }).catch(error => console.log(error));
        },
        exportJson(){
          event.preventDefault();
          this.axios.post('export/settings',this.form).then(response => {
            this.swalTransactionCompleted();
            window.location.href = server_details.BASE_SERVER_URL+"/export-settings/"+response.data;
          }).catch(error => {
            console.log(error)
            this.swal_transaction_error_data.text = error.response.data;
            this.swalRequestError();
          });
        },
      }
    }
</script>
